import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Shell, labelStyle, inputStyle, btn } from './ForgotPassword';

// First-login gate for a member an operator created with a temporary password
// (scripts/add-org-user.js sets users.must_change_password). App.jsx renders THIS instead of the
// whole app while the flag is set, so there is no route to slip past it — not the sidebar, not a
// pasted URL. Choosing a password clears the flag server-side and the app appears.
//
// No current-password field on purpose: the user just authenticated to reach this screen, and the
// password they'd be re-typing is one an operator handed them.
export default function ForcePasswordChange() {
  const { refresh, logout } = useAuth();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) return setError('Password must be at least 8 characters.');
    if (password !== confirm) return setError('The two passwords do not match.');
    setLoading(true);
    try {
      const r = await fetch('/api/auth/change-password', {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || 'Could not set your password.');
      // Re-read /api/auth/me so must_change_password flips false in context and the gate lifts.
      await refresh();
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const focus = (e) => Object.assign(e.target.style, { ...inputStyle, borderColor: 'var(--teal)' });
  const blur = (e) => Object.assign(e.target.style, inputStyle);

  return (
    <Shell title="Choose a password">
      <p style={{ fontSize: 14, color: 'var(--gray-300)', lineHeight: 1.6, marginTop: -6, marginBottom: 22 }}>
        Your account was set up with a temporary password. Pick your own before you continue.
      </p>
      <form onSubmit={submit}>
        <label style={labelStyle}>New password (8+ characters)</label>
        <input type="password" autoFocus autoComplete="new-password" value={password}
          onChange={e => setPassword(e.target.value)} placeholder="••••••••"
          style={inputStyle} onFocus={focus} onBlur={blur} />

        <label style={labelStyle}>Confirm password</label>
        <input type="password" autoComplete="new-password" value={confirm}
          onChange={e => setConfirm(e.target.value)} placeholder="••••••••"
          style={inputStyle} onFocus={focus} onBlur={blur} />

        {error && (
          <div style={{
            background: 'rgba(184, 84, 80,0.12)', border: '1px solid rgba(184, 84, 80,0.3)',
            borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 18,
          }}>{error}</div>
        )}

        <button type="submit" disabled={loading} style={btn(loading)}>
          {loading ? 'Saving…' : 'Set password & continue'}
        </button>
      </form>

      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <span onClick={logout} style={{ fontSize: 13, color: 'var(--gray-500)', cursor: 'pointer' }}>
          Sign out
        </span>
      </div>
    </Shell>
  );
}
